module.exports = __webpack_public_path__ + "static/fonts/CeraPro-Medium.9c2cba7.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/CeraPro-Medium.woff2
// module id = dTJN
// module chunks = 1